import { render, staticRenderFns } from "./DependencyPopup.vue?vue&type=template&id=673af060&"
import script from "./DependencyPopup.vue?vue&type=script&lang=js&"
export * from "./DependencyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673af060')) {
      api.createRecord('673af060', component.options)
    } else {
      api.reload('673af060', component.options)
    }
    module.hot.accept("./DependencyPopup.vue?vue&type=template&id=673af060&", function () {
      api.rerender('673af060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/DependencyPopup.vue"
export default component.exports